import useBaseFetch from 'src/internal/fetch/useBaseFetch';

import type {
  FetchHookOptions,
  FetchState,
  FetchUrl,
} from 'src/internal/shared/fetch/types';

/**
 *
 * @see https://sail.stripe.me/data/api/useJsonFetch
 */
export default function useJsonFetch<TData = unknown>(
  /** The URL of the resource to be fetched. */
  url: FetchUrl,
  /** An object containing custom settings to be applied to the request. */
  options: FetchHookOptions<TData> = {},
): FetchState<TData> {
  return useBaseFetch<TData>(url, options, 'json');
}
